/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
(function(a){a.fn.prepareTransition=function(){return this.each(function(){var b=a(this);b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",function(){b.removeClass("is-transitioning")});var c=["transition-duration","-moz-transition-duration","-webkit-transition-duration","-o-transition-duration"];var d=0;a.each(c,function(a,c){d=parseFloat(b.css(c))||d});if(d!=0){b.addClass("is-transitioning");b[0].offsetWidth}})}})(jQuery);
//https://www.xtremeskins.co.uk/products/samsung-galaxy-s21-skins?variant=33295437201471
(function CustomProduct() {
 'use strict';
  //return;
  
  var productJSON = JSON.parse($('[data-product-json]').html());
  var variants = productJSON.variants;
  var variantSelected = variantSelectedData();
  
  $(window).on('cc-variant-updated', function(evt, detail){
    liveCustomization(detail.product, detail.variant)
  });

  $(document).on('cartModal:open', getProductImagesFromHandle);

  $('.material-select, .logo-select').on('change', materialSelect);
  $('#ViewProtectorSelect').on('change', protectorSelect);
  $('#GelSelect').on('change', gelSelect);
  $('#SetLogo').on('change', logoSelect);
  

  setLines();
  setImages();
  if (variantSelected.isCustom) updatePrice();

  $(function() {
    if (!$('#ViewsWrap').length) return;

    var i = 0;
    var il = variants.length;

    var customOptions = [];

    for (; i < il; i += 1) {

      var variant = variants[i];
      var options = variant.options;
      var o = 0;
      var ol = options.length;

      for (; o < ol; o += 1) {
        var option = options[o];
        var optionClean = option.replace(/\s/g, '').toLowerCase();

        if (optionClean === 'custom') {
          customOptions = customOptions.concat(options);
        }
      }
    }

    var c = 0;
    var cl = customOptions.length;

    for (; c < cl; c += 1) {

      var optionStr = customOptions[c];
      var optionStrClean = optionStr.replace(/\s/g, '').toLowerCase();


      if (optionStrClean !== 'custom') {
        $('.selector-wrapper [value="' + optionStr + '"]').remove();
      }
    }
  });

  function logoSelect() {
    if ($('.logo-select').is(':checked')) {
      appendImages([{
        src: this.getAttribute('data-url'),
        index: this.getAttribute('data-view')
      }]);

    } else {
      appendImages([{
        src: null,
        index: this.getAttribute('data-view')
      }]);
    }
  }
  
  function variantSelectedData() {
    var selectors = $('.selector-wrapper select');
    var i = 0;
    var il = selectors.length;
    var isCustom = false;
    var customIndex;

    for (; i < il; i += 1) {
      var selectedValueClean = selectors[i].value.replace(/\s/g, '').toLowerCase();
      if (selectedValueClean === 'custom') {
        isCustom = true;
        customIndex = i;
        break;
      }
    }
    
    return {
      isCustom: isCustom,
      customIndex: customIndex
      
    }
  }

  function liveCustomization(product, variant) {
    if (isCustomProduct(product) === false) return;

    var selectors = $('.selector-wrapper select');
    var variantSelected = variantSelectedData();
    var isCustom = variantSelected.isCustom;
    var customIndex = variantSelected.customIndex;
    
    //console.log('customIndex', customIndex, isCustom)

    if (isCustom) {
      $('[data-gallery]').attr('data-gallery', 'custom');
      $('[data-product-gallery-view]').attr('data-product-gallery-view', 'custom');
      $('[data-gallery]').addClass('zoom-off');
      $('#CustomizationViews').removeClass('views-hidden');
      $('.property-line').prop('disabled', true);

      $('#SetLogo').trigger('change');

      updatePrice();
      setLines();
      hideSelectors(selectors, customIndex);

    } else {
      $('[data-gallery]').attr('data-gallery', 'default');
      $('[data-product-gallery-view]').attr('data-product-gallery-view', 'default');
      $('[data-gallery]').removeClass('zoom-off');
      $('#CustomizationViews').addClass('views-hidden');
      $('.property-line').prop('disabled', true);
      $('.property-logo-line').prop('disabled', true);   

      showSelectors(selectors);
    }
  }

  function getSelectedTypes() {
    var selectedTypes = [];
    var selectElements = $.makeArray($('.material-select, .protector-select'))

    selectElements.forEach(function(node) {
      var selectedOption = $(node).find(':selected');
      var dataType = selectedOption.attr('data-type');

      if (dataType !== 'unselected') selectedTypes.push(dataType);
    });


    if (!selectedTypes.length) {
      var firstMaterialSelect = selectElements[0];
      var firstMaterialOption = $(firstMaterialSelect).find('option')[1];
      var firstOptionValue = $(firstMaterialOption).val();
      var firstOptionType = $(firstMaterialOption).attr('data-type');

      $(firstMaterialSelect).val(firstOptionValue).trigger('change');
      selectedTypes.push(firstOptionType);
    }

    if ($('#GelSelect').prop('checked')) selectedTypes.push('gel');

    return selectedTypes;
  }

  function setLines() {
    var selectElements = $('.material-select, .protector-select');
    var i = 0;
    var il = selectElements.length;

    for (; i < il; i += 1) {
      var selectedElement = selectElements[i],
        selectedOption = $(selectedElement).find(':selected'),
        dataView = selectedOption.attr('data-view'),
        dataType = selectedOption.attr('data-type'),
        dataUrl = selectedOption.attr('data-url'),
        content = selectedOption.val(),
        line = $('#' + dataView + '-line');

      if (dataType === 'unselected') {
        line.val(content);
        line.prop('disabled', true);

      } else {
        line.prop('disabled', false);
        line.val(content.replace(/\_/g, ' '));
      }
    }

    if ($('#GelSelect').length) {
      var line = $('.property-gel-line')

      if ($('#GelSelect').prop('checked')) {
        line.val('yes');
        line.prop('disabled', false);
      } else {
        line.val('no');
        line.prop('disabled', true);
      }
    }

    if ($('#SetLogo').length) {
      var line = $('.property-logo-line');

      if ($('#SetLogo').prop('checked')) {
        line.val('yes');
        line.prop('disabled', false);
      } else {
        line.val('no');
        line.prop('disabled', false);
      }
    }
  }


  function materialSelect(event) {
    var type = this.getAttribute('data-type');

    if (type === 'front' && this.value !== 'unselected') {
      $('#ViewProtectorSelect').val('unselected').trigger('change');
    }

    setLines();
    setImages();
    updatePrice();
  }

  function protectorSelect(event) {
    var dataView = this.getAttribute('data-view');

    if (this.value === 'unselected') {
      //document.getElementById(dataView).removeAttribute('style');
    } else {
      $('.material-select[data-type="front"]').val('unselected').trigger('change');
    }

    var protector = 'protector-' + this.value;

    var i = 0;
    var images = productJSON.images;
    var il = images.length;

    for (; i < il; i += 1) {
      if (images[i].indexOf(protector) !== -1) {

        var dataUrl = images[i];
        break;
      }
    }

    if (dataUrl) {
      appendImages([{
        src: dataUrl,
        index: dataView
      }]);

    } else {
      appendImages([{
        src: null,
        index: dataView
      }]);
    }

    setLines();
    updatePrice();
  }

  function updatePrice() {
    var $mainSelect = $('[name="id"]');
    var selectedTypes = getSelectedTypes();
    var customVariantId = getCustomVariantId(selectedTypes, variants);
    var currentVariantId = parseInt($mainSelect.val());

    if (customVariantId !== currentVariantId) {
      $mainSelect.val(customVariantId).trigger('change');
    }
  }

  function gelSelect(event) {
    setLines();
    updatePrice();
  }

  function setImages() {
    var images = $.makeArray($('.material-select')).map(function(node, index){
      var selectedOption = $(node).find(':selected');
      var dataUrl = selectedOption.attr('data-url');
      var dataView = $(node).attr('data-view');
      return {
        src: dataUrl,
        index: index
      }
    });

    appendImages(images);
  }

  function appendImages(images){
    images.map(function(data){
      if (data.src) {
        var img = document.createElement('img');
        img.src = data.src;
        img.className = 'customization-view customization-view-new';
        img.setAttribute('data-view', data.index);

        img.onload = function () {
          this.className = 'customization-view';
        }

        $(img).on('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function(){
          var dataView = this.getAttribute('data-view');
          var nodes = $('img[data-view=' + dataView + ']');

          if (nodes.length !== 1) {
            this.className = 'customization-view customization-view-xxx';
            $('img[data-view=' + dataView + ']').not('.customization-view-xxx').remove();
            this.className = 'customization-view';
          }
        });

        $('#ViewsWrap').append(img);

      } else {
        var $img = $('img[data-view=' + data.index + ']');
        $img.on('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function(){
          $(this).remove();
        });

        $img.css('opacity', 0);
      }
    });
  }

  function getCustomVariantId(selectedTypes, variants) {
    var v = 0;
    var vl = variants.length;

    for (; v < vl; v += 1) {
      var variant = variants[v];
      var variantArr = variant.title.replace(/\+/g, '/').toLowerCase().split('/');

      var i = 0;
      var il = variantArr.length;

      for (; i < il; i += 1) {
        variantArr[i] = variantArr[i].trim().replace(' ', '_');
      }

      var index = variantArr.indexOf('custom');

      if (index !== -1) {
        variantArr.splice(index, 1);

        if ($(variantArr).not(selectedTypes).length === 0 && $(selectedTypes).not(variantArr).length === 0) {
          return variant.id;
          break;
        }
      }
    }
  }

  function isCustomProduct(product) {
    var options = product.variants.map(function(variant) {return variant.options}).flat();

    return options.some(function(option){
      return option.replace(/\s/g, '').toLowerCase() === 'custom';
    });
  }

  function getRegularVariantId(variants) {
    var lastSelected = $('.selector-wrapper select').not('.select-replaced').map(function() {
      return this.value;
    }).get().join('/').replace(/\s/g, '').toLowerCase();

    var i = 0;
    var il = variants.length;

    for (; i < il; i += 1) {
      var variant = variants[i];
      var variantTitle = variant.title.replace(/\s/g, '').toLowerCase();

      if (lastSelected === variantTitle) {
        return variant.id;
        break;
      }
    }

    return false;
  }

  function getFirstRegularVariantId(variants) {
    var i = 0;
    var il = variants.length;

    for (; i < il; i += 1) {
      var variant = variants[i];

      if (variant.available) {

        var variantArr = variant.title.replace(/\s/g, '').replace(/\+/g, '/').toLowerCase().split('/');
        var index = variantArr.indexOf('custom');

        if (index === -1) {
          return variant.id;
          break;
        }
      }
    }
  }

  function hideSelectors(selectors, index) {
    $.makeArray(selectors).forEach(function(node, i){
      if (i !== index) $(node.parentElement).addClass('selector-hidden');
    });
  }

  function showSelectors(selectors) {
    $('.selector-hidden').removeClass('selector-hidden');
  }

  function getProductImagesFromHandle() {
    if (typeof productsHandle === 'undefined') {
      return;
    }

    var i = 0,
      il = productsHandle.length,
      deferreds = [];

    for (; i < il; i += 1) {
      deferreds.push($.getJSON('/products/' + productsHandle[i] + '.js'));
    }

    var obj = {};

    $.when.apply(null, deferreds).done(function(requests) {
      var x = 0,
        xl = deferreds.length;

      for (; x < xl; x += 1) {

        var request = deferreds[x];

        if (request.status === 200) {
          var responseJSON = request.responseJSON;
          obj[responseJSON.handle] = responseJSON.images;
        }
      }

      window.ShopifyLiveCustomizationImages = obj;
      setCartCustomImages();
    });
  }

  function setCartCustomImages() {

    var images = window.ShopifyLiveCustomizationImages;

    var cartLines = $('.item_property'),
      c = 0,
      cl = cartLines.length

    for (; c < cl; c += 1) {

      var lineElement = cartLines[c],
        dataHandle = lineElement.getAttribute('data-handle'),
        dataProperties = lineElement.getAttribute('data-properties').split(','),
        cartImageContainer = $(lineElement).parent().parent().find('.cart-product__image');

      var productImages = images[dataHandle];

      if (!productImages) continue;
      if (!dataProperties.length) continue;

      var i = 0,
        il = productImages.length

      for (; i < il; i += 1) {

        var image = productImages[i];

        if (image.indexOf(dataProperties[0]) > -1 && image.indexOf(dataProperties[1]) > -1) {
          var src = image.replace('.png?', '_200x.png?');
          var customImg = $('<img src="' + src + '" class="cart_image-view">');
          cartImageContainer.append(customImg);
        }

        if (image.indexOf('logo.png') > -1) {
          var src = image.replace('.png?', '_200x.png?');
          var customImg = $('<img src="' + src + '" class="cart_image-view cart_image-logo">');
          cartImageContainer.append(customImg);
        }
      }
    }
  }

})();